






















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import env from '@/env';
import AppPreloader from '@/components/App/AppPreloader.vue';
import { Cutoverplan } from '@/types';
import SelectEnvironmentDialog from '@/components/Dialogues/SelectEnvironmentDialog.vue';
import CutoverplanHashDialog from '@/components/Dialogues/CutoverplanHashDialog.vue';
import { Module } from '@/interfaces/Module';
import CheckDiffDialog from '@/components/Dialogues/CheckDiffDialog.vue';
import CloneCutoverplanDialog from '@/components/Dialogues/CloneCutoverplanDialog.vue';
import AppSAPBadge from '@/components/App/AppSAPBadge.vue';
import HashDialog from '@/components/Dialogues/HashDialog.vue';
import { Wave } from '@/interfaces/Wave';
import { Phase } from '@/interfaces/Phase';

@Component({
  components: {
    HashDialog,
    AppSAPBadge,
    CloneCutoverplanDialog,
    CheckDiffDialog,
    CutoverplanHashDialog,
    SelectEnvironmentDialog,
    AppPreloader
  }
})
export default class CutoverplansListView extends Vue {
  dialog = false;

  new_name = '';

  new_abbreviation = '';

  private showHashDialog = false;

  new_sap = false;

  selected_cutoverplan = 0;

  cutoverplansByWaveId: Record<number, Cutoverplan[]> = {};

  export_all_path = '/home/cutovertool_sftp_n84/export';

  cutoverplans: Cutoverplan[] = [];

  hashCutoverplan?: any = {};

  hashEnvironmentId = 0;

  hashDialog = false;

  hashcode?: any = false;

  env?: any;

  allBlueprints: Module[] = [];

  get blueprintsSelect() {
    return this.allBlueprints.map((blueprint: Module) => {
      const preferredLanguage = blueprint.moduleLanguages?.find(
        (language: any) => language.languageId === this.$store.state.user.languageId
      );
      return {
        text: preferredLanguage?.name || blueprint.moduleLanguages?.[0]?.name,
        value: blueprint.id
      };
    });
  }

  filter: { blueprints: number[]; archived: boolean } = {
    blueprints: [],
    archived: false
  };

  getWaveName(wave: Wave) {
    const preferredLanguage = wave.waveLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    if (preferredLanguage) return preferredLanguage.name;
    return wave.waveLanguages?.[0]?.name;
  }

  isEmpty(cutoverplan: Cutoverplan) {
    return !(cutoverplan.modules.length && cutoverplan.environments.length);
  }

  @Watch('filter.blueprints')
  watchFilterBlueprints() {
    this.refreshCutoverplanList();
  }

  @Watch('filter.archived')
  watchFilterArchived() {
    this.refreshCutoverplanList();
  }

  async refreshCutoverplanList() {
    const { data: cutoverplans } = await axios.get(`${env.backend_url}/all_cutoverplans`, {
      params: this.filter
    });
    this.cutoverplans = cutoverplans;
  }

  @Watch('cutoverplans')
  watchCutoveprlans() {
    const cutoverplansByWaveId: Record<number, Cutoverplan[]> = { 0: [] };
    this.cutoverplans.forEach((cutoverplan: Cutoverplan) => {
      if (!cutoverplan.wave_id) {
        cutoverplan.wave_id = 0;
      } else if (!cutoverplansByWaveId[cutoverplan.wave_id]) {
        cutoverplansByWaveId[cutoverplan.wave_id] = [];
      }
      cutoverplansByWaveId[cutoverplan.wave_id].push(cutoverplan);
    });
    for (const wave_id of Object.keys(cutoverplansByWaveId)) {
      cutoverplansByWaveId[+wave_id] = cutoverplansByWaveId[+wave_id].sort(
        (a: Cutoverplan, b: Cutoverplan) => a.position_in_wave - b.position_in_wave
      );
    }
    this.cutoverplansByWaveId = cutoverplansByWaveId;
  }

  all_waves = [];

  async createCutoverplan() {
    this.dialog = false;
    const { data: cutoverplan } = await axios.post(`${env.backend_url}/cutoverplan/create`, {
      is_blueprint: 1,
      name: this.new_name,
      app_abbreviation: this.new_abbreviation,
      sap: this.new_sap
    });
    this.$store.commit('addCutoverplanToAllCutoverplans', cutoverplan);
    await this.$router.push({ path: `/cutoverplan/${cutoverplan.id}/` });
  }

  async exportAll() {
    const { status } = await axios.post(`${env.backend_url}/cutoverplan/export_all`, {
      directory: this.export_all_path
    });
    // eslint-disable-next-line no-alert
    if (status === 200) alert('export complete');
  }

  async hash(cutoverplan: Cutoverplan, environment_id: number | 'cancel') {
    if (environment_id === 'cancel') return;
    const { data: response } = await axios.get(
      `${env.backend_url}/cutoverplan/hash/${cutoverplan.id}?environment_id=${environment_id}`
    );
    this.hashCutoverplan = cutoverplan;
    this.hashcode = response;
    this.hashEnvironmentId = environment_id;
    this.hashDialog = true;
  }

  async cloneCutoverplan(cutoverplan: Cutoverplan) {
    const { data: clone } = await axios.post(`${env.backend_url}/cutoverplan/clone`, cutoverplan);
    this.$store.commit('addCutoverplanToAllCutoverplans', clone);
    await this.$router.push({ path: `/cutoverplan/${clone.id}/` });
  }

  async archiveCutoverplan(cutoverplan: Cutoverplan) {
    await axios.post(`${env.backend_url}/cutoverplan/archive/${cutoverplan.id}`);
    await this.refreshCutoverplanList();
  }

  async handleHashDialogClose(action: string) {
    this.hashDialog = false;
    if (action === 'cancel') {
      return;
    }
    if (action === 'save') {
      await axios.post(`${env.backend_url}/cutoverplan/hash/`, {
        cutoverplan_id: this.hashCutoverplan.id,
        environment_id: this.hashEnvironmentId,
        hash: this.hashcode.hash
      });
    }
  }

  goToCop() {
    this.$router.push(`cutoverplan/${this.selected_cutoverplan}/`);
  }

  async created() {
    this.env = env;
    this.$emit('showPreloader');
    const { data } = await axios.get(`${env.backend_url}/all_waves`);
    this.all_waves = data;
    const { data: cutoverplans } = await axios.get(`${env.backend_url}/all_cutoverplans`);
    this.cutoverplans = cutoverplans;
    this.$emit('loadingFinished');

    const { data: blueprints } = await axios.get(`${env.backend_url}/module/blueprints/all`);
    this.allBlueprints = blueprints;
  }
}
